import {
  slideToggle,
  toggleClass,
  addClass,
  slideUp,
  removeClass,
} from '../common-functions';
import { DEFAULT_CSS_CLASS } from '@constants';
import classnames from 'classnames';
import './editor.scss';

const {
  blockEditor: { useBlockProps, useInnerBlocksProps, useSetting },
  element: { useEffect, useRef },
} = wp;

const BLOCKS_TEMPLATE = [
  ['b3rg/icon-block', {}],
  ['core/heading', { placeholder: 'Accordion Title' }],
];

const constants = require('@constants');
const defaultCssClass = constants.DEFAULT_CSS_CLASS.ACCORDION;

const clzFloatItemWrapper = `.${defaultCssClass}__flt-itm-wrpr`;
const clzItems = `.${defaultCssClass}__itm-wrpr`;
const activeClass = 'active';

const changeAccordionHeightOnClick = (acc, currentId) => {
  const floatPannels = acc.querySelectorAll(clzFloatItemWrapper);
  const arrayLength = floatPannels.length;
  if (arrayLength === 0) return;

  const activePanel = acc.querySelector(`[data-float-panel-id='${currentId}']`);
  const activePanelHeight = activePanel.children[0].offsetHeight;
  acc.children[0].style.minHeight = activePanelHeight + 'px';
};

const Edit = ({ name, context, clientId, attributes }) => {
  const { isExpanded } = attributes;
  const { expandAll, uniqueID } = context;

  const defaultCssClass = DEFAULT_CSS_CLASS.ACCORDION;

  const ALLOWED_BLOCKS = useSetting(`custom.blocks.${name}.allowedBlocks`) ?? [
    'b3rg/icon-block',
    'core/image',
    'core/heading',
  ];
  const accHeaderRef = useRef(null);

  useEffect(() => {
    const headerEl = accHeaderRef.current;

    const onClick = (el) => {
      const acc = el.target.closest('[data-accordion]');
      const items = Array.from(acc.querySelectorAll(clzItems));
      const floatPannels = Array.from(
        acc.querySelectorAll(clzFloatItemWrapper),
      );

      const id = el.currentTarget.dataset.target;
      changeAccordionHeightOnClick(acc, id);
      const filterActiveItems = items.filter(
        (i) => i.classList.contains(activeClass) && i.dataset.itemId !== id,
      );

      filterActiveItems.forEach((element) => {
        const id = element.dataset.itemId;
        const body = acc.querySelector(`#${id}`);
        removeClass(element);
        slideUp(body);
      });

      const accordionItemWrapper = acc.querySelector(`[data-item-id="${id}"`);
      const accordionItemBody = acc.querySelector(`#${id}`);

      slideToggle(accordionItemBody);
      toggleClass(accordionItemWrapper);

      if (floatPannels.length > 0) {
        floatPannels.forEach((element) => {
          if (element.dataset.floatPanelId !== id) {
            removeClass(element);
          } else {
            addClass(element);
          }
        });
      }
    };

    headerEl?.addEventListener('click', onClick);
    return () => {
      headerEl?.removeEventListener('click', onClick); //NOSONAR
    };
  }, [clientId]);

  const blockProps = useBlockProps({
    className: `${defaultCssClass}__itm-hdr`,
  });

  const itmHdrWrpClass = classnames({
    [`${defaultCssClass}__itm-hdr-wrpr`]: true,
    [`active`]: isExpanded || expandAll,
  });

  const { children, ...innerBlocksProps } = useInnerBlocksProps(blockProps, {
    allowedBlocks: ALLOWED_BLOCKS,
    templateLock: false,
    template:
      useSetting(`custom.blocks.${name}.blocksTemplate`) ?? BLOCKS_TEMPLATE,
  });
  return (
    <div
      className={`${itmHdrWrpClass}`}
      data-target={uniqueID}
      ref={accHeaderRef}
    >
      <div {...innerBlocksProps}>{children}</div>
    </div>
  );
};

export default Edit;
